import type { GuardiansView } from "./guardiansParams";

export interface GuardiansLayoutState {
  view: GuardiansView;
  selectedAuditId: string | null;
  selectedScreeningId: string | null;
  showAlertPanel: boolean;
}

export interface GuardiansLayoutPanels {
  showAuditsInspector: boolean;
  showScreeningsInspector: boolean;
  mainColumnClass: string;
}

export function resolveGuardiansLayout(state: GuardiansLayoutState): GuardiansLayoutPanels {
  const showAuditsInspector = state.view === "audits" && state.selectedAuditId != null;
  const showScreeningsInspector = state.view === "screenings" && state.selectedScreeningId != null;
  const detailOpen = showAuditsInspector || showScreeningsInspector || state.showAlertPanel;

  let mainColumnClass = "flex-1";
  if (state.view === "conversation" || state.view === "stats") {
    mainColumnClass = "flex-1";
  } else if (detailOpen) {
    mainColumnClass = "w-[42%] max-w-[520px] shrink-0";
  }

  return {
    showAuditsInspector,
    showScreeningsInspector,
    mainColumnClass,
  };
}
